/* eslint-disable class-methods-use-this */
import { Inject, Injectable } from '@angular/core';
import * as angular from 'angular';
import { downgradeInjectable } from '@angular/upgrade/static';
import { EVENTS } from '../../constants/events';
import { MousetrapService } from './mousetrap.service';

interface ShortcutItem {
  command: string[];
  description: string;
  category: string;
}

export const SHORTCUTS_LIST: ShortcutItem[] = [
  {
    command: ['g i'],
    description: 'shortcuts.list.go_to_connections',
    category: 'shortcuts.list.category.navigation',
  },
  {
    command: ['g p'],
    description: 'shortcuts.list.go_to_packages',
    category: 'shortcuts.list.category.navigation',
  },
  {
    command: ['g j'],
    description: 'shortcuts.list.go_to_jobs',
    category: 'shortcuts.list.category.navigation',
  },
  {
    command: ['g c'],
    description: 'shortcuts.list.go_to_clusters',
    category: 'shortcuts.list.category.navigation',
  },
  {
    command: ['g s'],
    description: 'shortcuts.list.go_to_schedules',
    category: 'shortcuts.list.category.navigation',
  },
  {
    command: ['mod+s'],
    description: 'shortcuts.list.designer.save',
    category: 'shortcuts.list.category.designer',
  },
  {
    command: ['mod+a'],
    description: 'shortcuts.list.designer.select_all',
    category: 'shortcuts.list.category.designer',
  },
  {
    command: ['esc', 'mod+shift+a'],
    description: 'shortcuts.list.designer.deselect_components',
    category: 'shortcuts.list.category.designer',
  },
  {
    command: ['mod+f'],
    description: 'shortcuts.list.designer.vertical_align',
    category: 'shortcuts.list.category.designer',
  },
  {
    command: ['mod+z'],
    description: 'shortcuts.list.designer.undo',
    category: 'shortcuts.list.category.designer',
  },
  {
    command: ['ctrl+y', 'mod+shift+z'],
    description: 'shortcuts.list.designer.redo',
    category: 'shortcuts.list.category.designer',
  },
  {
    command: ['mod+x'],
    description: 'shortcuts.list.designer.cut',
    category: 'shortcuts.list.category.designer',
  },
  {
    command: ['mod+c'],
    description: 'shortcuts.list.designer.copy',
    category: 'shortcuts.list.category.designer',
  },
  {
    command: ['mod+v'],
    description: 'shortcuts.list.designer.paste',
    category: 'shortcuts.list.category.designer',
  },
  {
    command: ['?', 'mod+/'],
    description: 'shortcuts.list.shortcuts',
    category: 'shortcuts.list.category.application',
  },
];

@Injectable({
  providedIn: 'root',
})
export class NavigationHotkeysService {
  shortcuts = [
    {
      command: ['mod+s'],
      description: 'shortcuts.list.designer.save',
      category: 'shortcuts.list.category.designer',
      cb(e) {
        e.preventDefault();
        this.$rootScope.$broadcast(EVENTS.SHORTCUTS_DESIGNER_SAVE);
      },
    },
    {
      command: ['mod+a'],
      description: 'shortcuts.list.designer.select_all',
      category: 'shortcuts.list.category.designer',
      cb(e) {
        e.preventDefault();
        this.$rootScope.$broadcast(EVENTS.SHORTCUTS_DESIGNER_SELECT_ALL);
      },
    },
    {
      command: ['esc', 'mod+shift+a'],
      description: 'shortcuts.list.designer.deselect_components',
      category: 'shortcuts.list.category.designer',
      cb(e) {
        e.preventDefault();
        this.$rootScope.$broadcast(EVENTS.SHORTCUTS_DESIGNER_UNSELECT);
      },
    },
    {
      command: ['mod+f'],
      description: 'shortcuts.list.designer.vertical_align',
      category: 'shortcuts.list.category.designer',
      cb(e) {
        e.preventDefault();
        this.$rootScope.$broadcast(EVENTS.SHORTCUTS_DESIGNER_SELECT_VERTICAL_ALIGN);
      },
    },
    {
      command: ['mod+z'],
      description: 'shortcuts.list.designer.undo',
      category: 'shortcuts.list.category.designer',
      cb(e) {
        e.preventDefault();
        this.$rootScope.$broadcast(EVENTS.SHORTCUTS_DESIGNER_UNDO);
      },
    },
    {
      command: ['ctrl+y', 'mod+shift+z'],
      description: 'shortcuts.list.designer.redo',
      category: 'shortcuts.list.category.designer',
      cb(e) {
        e.preventDefault();
        this.$rootScope.$broadcast(EVENTS.SHORTCUTS_DESIGNER_REDO);
      },
    },
    {
      command: ['mod+x'],
      description: 'shortcuts.list.designer.cut',
      category: 'shortcuts.list.category.designer',
      cb(e) {
        e.preventDefault();
        this.$rootScope.$broadcast(EVENTS.SHORTCUTS_DESIGNER_CUT);
      },
    },
    {
      command: ['mod+c'],
      description: 'shortcuts.list.designer.copy',
      category: 'shortcuts.list.category.designer',
      cb(e) {
        e.preventDefault();
        this.$rootScope.$broadcast(EVENTS.SHORTCUTS_DESIGNER_COPY);
      },
    },
    {
      command: ['mod+v'],
      description: 'shortcuts.list.designer.paste',
      category: 'shortcuts.list.category.designer',
      cb(e) {
        e.preventDefault();
        this.$rootScope.$broadcast(EVENTS.SHORTCUTS_DESIGNER_PASTE);
      },
    },
  ];

  mousetrap: any;

  constructor(@Inject('$rootScope') private $rootScope: any, private mousetrapService: MousetrapService) {
    this.mousetrap = this.mousetrapService.init();
  }

  init(category) {
    this.mousetrap.reset();
    this.shortcuts.forEach((s) => {
      this.mousetrap.bind(s.command, s.cb.bind(this));
    });
  }

  bindCategories(categories) {
    this.shortcuts.forEach((s) => {
      if (categories.includes(s.category)) {
        this.mousetrap.bind(s.command, s.cb.bind(this));
      }
    });
  }

  unbindCategories(categories) {
    this.shortcuts.forEach((s) => {
      if (categories.includes(s.category)) {
        this.mousetrap.unbind(s.command, s.cb.bind(this));
      }
    });
  }

  pause() {
    this.mousetrap.pause();
  }

  unpause() {
    this.mousetrap.unpause();
  }

  reset() {
    this.mousetrap.reset();
  }

  bindings() {
    return this.shortcuts;
  }

  showCheatSheet() {
    this.$rootScope.$broadcast(EVENTS.SHORTCUTS_DISPLAY_LIST, this.shortcuts);
  }
}

((window as any).xplenty as angular.IModule).service(
  'NavigationHotkeys',
  downgradeInjectable(NavigationHotkeysService),
);
